<script>
  export default {
    name: 'services-root'
  }
</script>

<template>
  <!-- <div> -->
  <!-- <p>Resources base page</p> -->
  <router-view></router-view>
  <!-- </div> -->
</template>

<style></style>
